import React from "react";

function Notification({ message, type }) {
    const typeStyles = {
        ['SUCCESS']: 'bg-green-600 text-white',
        ['ERROR']: 'bg-red-600 text-white',
        ['WARNING']: 'bg-yellow-500 text-black',
        ['INFO']: 'bg-cyan-500 text-white',
    };

    return (
        <div className="fixed top-4 left-1/2 -translate-x-1/2 flex flex-col gap-2 z-50">
            <div className={`p-4 rounded-lg shadow-lg ${typeStyles[type]}`}>
                {message}
            </div>
        </div>
    );
}

export default Notification;
